import { Typography } from '@/shared/components/ui/typography'
import React from 'react'
import { Link } from 'react-router-dom'
import * as CookieConsent from 'vanilla-cookieconsent'

interface FooterLink {
  text: string
  href: string
}

interface FooterSection {
  title: string
  links: FooterLink[]
}

const footerSections: FooterSection[] = [
  /*{
    title: 'Company',
    links: [
      { text: 'Home', href: '#' },
      { text: 'For Companies', href: '#' },
      { text: 'For Individuals', href: '#' },
    ],
  },*/
  {
    title: 'Legal',
    links: [
      { text: 'Help', href: '#' },
      { text: 'Privacy', href: '#' },
      { text: 'Terms of use', href: '#' },
    ],
  },
]

export const Footer: React.FC = () => {
  return (
    <footer className="mt-16 max-w-full self-center px-6 pb-6 text-primary max-md:mt-10 md:w-[1235px] xl:px-0">
      <div className="flex w-full flex-col flex-wrap items-center px-px max-md:max-w-full md:flex-row">
        <nav className="my-auto flex min-w-60 items-center gap-6 self-stretch text-[13px] font-medium">
          {footerSections.map((section, index) => (
            <div
              key={index}
              className={`my-auto self-stretch ${index === 0 ? 'w-[193px]' : 'w-36'}`}
            >
              <Typography
                variant="body1"
                className="font-semibold leading-[25px] text-primary"
              >
                {section.title}
              </Typography>
              <ul className="mt-3.5 flex flex-col gap-3">
                {section.links.map((link, linkIndex) => (
                  <li key={linkIndex}>
                    <a
                      href={link.href}
                      className="text-primary transition-opacity hover:opacity-70"
                    >
                      {link.text}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </nav>
        <div className="mt-12 flex shrink grow flex-col gap-3 self-stretch text-sm font-normal leading-5 tracking-[-0.24px] md:-order-1 md:my-auto md:w-[173px]">
          <img
            src="https://cdn.builder.io/api/v1/image/assets/fe2c5ce2c4a6499bb0a9fb0e8c30a2c9/a7e6c6b42153118c2fc56e57d1b4be80bde5762a?placeholderIfAbsent=true"
            alt="Company Logo"
            className="aspect-[33/32] w-[33px] fill-primary object-contain"
          />
          <p className="text-xs leading-4 md:text-sm">
            Learn faster. Work smarter. Skill up in AI with Mydra!
          </p>
          <Link
            to="https://www.linkedin.com/company/studentfinance"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              src="https://cdn.builder.io/api/v1/image/assets/fe2c5ce2c4a6499bb0a9fb0e8c30a2c9/876579cbc3e8c0fcd564f30233cb95328f9c768d?placeholderIfAbsent=true"
              alt="Social Media"
              className="aspect-[1] w-[22px] object-contain"
            />
          </Link>
          <button
            type="button"
            onClick={() => {
              CookieConsent.showPreferences()
            }}
            className="w-fit text-left text-sm font-normal leading-5 tracking-[-0.24px] text-primary"
          >
            Manage cookie preferences
          </button>
          <div className="w-full max-md:max-w-full md:mt-4">
            <Typography
              variant="body2"
              className="text-primary max-md:max-w-full"
            >
              2025 All Rights ©Mydra
            </Typography>
          </div>
        </div>
      </div>
    </footer>
  )
}
